import React from 'react';
import './index.css'

export const PropertyCard = ({ data }) => {
    return (
        <div className='propery-card p-0'>
           
                    {data.map(item =>
                        <div className='row t-row'>
                            <div className='col-md-6 t-col key-class'>
                                {item.key}
                            </div>
                            <div className='col-md-6 t-col'>
                                {item.value}
                            </div>
                        </div>
                    )}
                
        </div>
    );
}

